var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTyre(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.085 7c0 1.913-.342 3.707-.961 5.05C5.552 13.29 4.794 14 4.042 14c-.75 0-1.51-.71-2.081-1.95C1.34 10.707 1 8.913 1 7c0-1.913.341-3.707.96-5.05C2.534.71 3.292 0 4.043 0l.044.001a.355.355 0 00.07.007h.028c.704.083 1.404.78 1.94 1.942.62 1.343.96 3.137.96 5.05zM5.412 4.402c-.398-1.03-.965-1.246-1.37-1.246-.404 0-.971.216-1.37 1.246-.258.67-.401 1.592-.401 2.598 0 1.006.143 1.928.402 2.598.398 1.03.965 1.246 1.37 1.246.404 0 .971-.216 1.37-1.246.258-.67.401-1.592.401-2.598 0-1.006-.143-1.928-.402-2.598z",
    fill: "#A4A4A4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.043 9.754C3.58 9.754 3.1 8.724 3.1 7s.48-2.754.943-2.754c.463 0 .942 1.03.942 2.754s-.479 2.754-.942 2.754zM8.78 0H6.047c.627.345 1.985 2.96 1.985 6.437 0 5.485-1.51 6.934-1.985 7.514h2.588c.643 0 1.298-.176 1.733-.65.813-.887 1.928-2.793 1.928-6.864 0-3.042-1.116-4.961-2.023-5.899C9.888.141 9.333 0 8.78 0z",
    fill: "#A4A4A4"
  })));
}

export default SvgTyre;